import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class AnimationService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Animation';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'animation/0', 'title': 'FadeIn Left', 'theme': 'layout1' },
      { 'url': 'animation/1', 'title': 'FadeIn Up', 'theme': 'layout2' },
      { 'url': 'animation/2', 'title': 'BounceIn', 'theme': 'layout3' },
      { 'url': 'animation/3', 'title': 'ZoomIn', 'theme': 'layout4' },
      { 'url': 'animation/4', 'title': 'BounceIn Left', 'theme': 'layout5' },
      { 'url': 'animation/5', 'title': 'FadeIn', 'theme': 'layout6' },
      { 'url': 'animation/6', 'title': 'BounceIn Right And Left And ZoomIn', 'theme': 'layout7' },
      { 'url': 'animation/7', 'title': 'SlideIn Left', 'theme': 'layout8' },
      { 'url': 'animation/8', 'title': 'SlideIn Up And ZoomIn', 'theme': 'layout9' },
      { 'url': 'animation/9', 'title': 'FadeIn Right', 'theme': 'layout10' }

    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'FadeIn Left',
      'items': [
        {
          'id': 1,
          'title': 'Gibbs Farm, Karatu, Tanzania',
          "isChecked": false,
          'image': 'assets/imgs/avatar/1.jpg'
        },
        {
          'id': 2,
          'title': 'The Mulia, Bali, Indonesia',
          "isChecked": true,
          'image': 'assets/imgs/avatar/2.jpg'
        },
        {
          'id': 3,
          'title': 'Turtle Island, Fiji',
          "isChecked": false,
          'image': 'assets/imgs/avatar/3.jpg'
        },
        {
          'id': 4,
          'title': 'Ellerman House, Cape Town',
          "isChecked": false,
          'image': 'assets/imgs/avatar/4.jpg'
        },
        {
          'id': 5,
          'title': 'J.K. Place Firenze, Florencer',
          "isChecked": true,
          'image': 'assets/imgs/avatar/5.jpg'
        },
        {
          'id': 6,
          'title': 'The Oberoi, Mumbai',
          "isChecked": false,
          'image': 'assets/imgs/avatar/6.jpg'
        }
      ]
    }
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'FadeIn Up',
      'headerImage': 'assets/imgs/background/1.jpg',
      'title': 'Hotels',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'seller': 'LONDON, UNITED KINGDOM',
          'image': 'assets/imgs/avatar/1.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 2,
          'title': 'The Alpina Gstaad',
          'seller': 'GSTAAD, SWITZERLAND',
          'image': 'assets/imgs/avatar/2.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 3,
          'title': 'Belmond El Encanto',
          'seller': 'SANTA BARBARA, CALIFORNIA',
          'image': 'assets/imgs/avatar/7.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 4,
          'title': 'Casa Palmero',
          'seller': 'PEBBLE BEACH, CALIFORNIA',
          'image': 'assets/imgs/avatar/8.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 5,
          'title': 'Encore Macau',
          'seller': 'MACAU, CHINA',
          'image': 'assets/imgs/avatar/11.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 6,
          'title': 'Nobu Ryokan Malibu',
          'seller': 'MALIBU, CALIFORNIA',
          'image': 'assets/imgs/avatar/12.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        },
        {
          'id': 7,
          'title': 'Park Hyatt New York',
          'seller': 'NEW YORK, NEW YORK',
          'image': 'assets/imgs/avatar/3.jpg',
          'oldPrice': '$42.99',
          'category': 'rooms',
          'newPrice': '$35.99'
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'BounceIn',
      'items': [
        {
          'id': 1,
          "title": "New York Hilton Midtown",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 2,
          "title": "New York Marriott Marquis",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/2.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 3,
          "title": "Grand Hyatt New York",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/3.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 4,
          "title": "The Roosevelt Hotel",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/4.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 5,
          "title": "Kennedy Fried Chicken",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/9.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 6,
          "title": "PKorilla BBQ",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/10.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 7,
          "title": "BurritoVille",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/11.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        },
        {
          'id': 8,
          "title": "Mo Gridder's",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/12.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
        }
      ]
    };
  }

  //* Data Set for page 4
  getDataForLayout4 = (): any => {
    return {
      'toolbarTitle': 'ZoomIn',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': '8 km to center',
          'price': '$ 340 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'title': 'Encore Macau',
          'subtitle': '8 km to center',
          'price': '$ 200 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'title': 'Bulgari Hotel London',
          'subtitle': '8 km to center',
          'price': '$ 500 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Belmond El Encanto',
          'subtitle': '8 km to center',
          'price': '$ 100 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'The Alpina Gstaad',
          'subtitle': '8 km to center',
          'price': '$ 600 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  //* Data Set for page 5
  getDataForLayout5 = (): any => {
    return {
      'toolbarTitle': 'BounceIn Left',
      'items': [
        {
          'id': 1,
          "title": "O’Donnell’s Pub",
          "image": "assets/imgs/avatar/8.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 2,
          "title": "4th Avenue Pub",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 3,
          "title": "Perdition",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 4,
          "title": "John Sullivan’s",
          "image": "assets/imgs/avatar/5.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 5,
          "title": "Mo Gridder's",
          "image": "assets/imgs/avatar/12.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 6,
          "title": "BurritoVille",
          "image": "assets/imgs/avatar/11.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 7,
          "title": "PKorilla BBQ",
          "image": "assets/imgs/avatar/10.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 8,
          "title": "Kennedy Fried Chicken",
          "image": "assets/imgs/avatar/9.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        }
      ]
    }
  }

  //* Data Set for page 6
  getDataForLayout6 = (): any => {
    return {
      'toolbarTitle': 'FadeIn',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': '8 km to center',
          'price': '$ 340 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'title': 'Encore Macau',
          'subtitle': '8 km to center',
          'price': '$ 200 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'title': 'Bulgari Hotel London',
          'subtitle': '8 km to center',
          'price': '$ 500 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Belmond El Encanto',
          'subtitle': '8 km to center',
          'price': '$ 100 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'The Alpina Gstaad',
          'subtitle': '8 km to center',
          'price': '$ 600 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    }
  }

  //* Data Set for page 7
  getDataForLayout7 = (): any => {
    return {
      'toolbarTitle': 'BounceIn Right And Left And ZoomIn',
      'headerImage': 'assets/imgs/background/6.jpg',
      'toolBarTitle': 'Parallax-title',
      'title': 'Philippines',
      'rating': '4.6',
      'icon': 'star',
      'items': [
        {
          'id': 1,
          'title': 'Best Hotels',
          'seeAll': 'See All',
          'items': [
            {
              'id': 1,
              'title': 'The Beekman',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/1.jpg',
            },
            {
              'id': 2,
              'title': 'Moxy NYC',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/2.jpg',
            },
            {
              'id': 3,
              'title': 'The Kimberly',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/3.jpg',
            },
            {
              'id': 4,
              'title': 'Roxy Hotel',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/4.jpg',
            }
          ]
        },
        {
          'id': 2,
          'title': 'Best Rooms',
          'seeAll': 'See All',
          'items': [
            {
              'id': 1,
              'title': '45 Park Lane',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/5.jpg',
            },
            {
              'id': 2,
              'title': 'The Alpina Gstaad',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/6.jpg',
            },
            {
              'id': 3,
              'title': 'Casa Palmero',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/7.jpg',
            },
            {
              'id': 4,
              'title': 'Encore Macau',
              'subtitle': 'Starting From $410.00',
              'image': 'assets/imgs/background/8.jpg',
            }
          ]
        },
      ]
    }
  }

  //* Data Set for page 8
  getDataForLayout8 = (): any => {
    return {
      'toolbarTitle': 'SlideIn Left',
      'allComments': '2121 Comments',
      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/avatar/17.jpg',
          'title': 'Erica Romaguera',
          'time': '18 August',
          'description': 'If you could have any kind of pet, what would you choose?',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 2,
          'image': 'assets/imgs/avatar/18.jpg',
          'title': 'Caleigh Jerde',
          'time': '18 August',
          'description': 'If you could learn any language, what would you choose?',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 3,
          'image': 'assets/imgs/avatar/19.jpg',
          'title': 'Lucas Schultz',
          'time': '18 August',
          'description': 'Life is about making an impact, not making an income.',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 4,
          'image': 'assets/imgs/avatar/20.jpg',
          'title': 'Carole Marvin',
          'time': '18 August',
          'description': `I\’ve learned that people will forget what you said,
                   people will forget what you did, but people will never forget how you made them feel`,
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 5,
          'image': 'assets/imgs/avatar/21.jpg',
          'title': 'Doriana Feeney',
          'time': '18 August',
          'description': 'Definiteness of purpose is the starting point of all achievement.',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 6,
          'image': 'assets/imgs/avatar/22.jpg',
          'title': 'Nia Gutkowski',
          'time': '18 August',
          'description': 'Life is what happens to you while you’re busy making other plans',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            }
          ],
        }
      ]
    }
  }

  //* Data Set for page 9
  getDataForLayout9 = (): any => {
    return {
      'toolbarTitle': 'SlideIn Up And ZoomIn',
      'image': 'assets/imgs/avatar/21.jpg',
      'title': 'Carolyn Guerrero',
      'subtitle': 'From New York',
      'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
      'button': 'Follow',
      'icon': "chatbubble-ellipses",
      'followers': 'Followers',
      'valueFollowers': '439',
      'following': 'Following',
      'valueFollowing': '297',
      'posts': 'Posts',
      'valuePosts': '43',
      'items': [
        {
          'id': 1,
          'category': 'Rooms',
          'backgroundCard': 'assets/imgs/background/5.jpg',
          'title': 'The Peninsula Beijing',
          'like': {
            'icon': 'thumbs-up',
            'text': 'Like',
            'number': '4',
            'isActive': true
          },
          'comment': {
            'icon': 'chatbubbles',
            'number': '4',
            'text': 'Comments',
            'isActive': false
          }
        },
        {
          'id': 2,
          'category': 'Rooms',
          'backgroundCard': 'assets/imgs/background/6.jpg',
          'title': 'The Peninsula Chicago',
          'like': {
            'icon': 'thumbs-up',
            'text': 'Like',
            'number': '4',
            'isActive': true
          },
          'comment': {
            'icon': 'chatbubbles',
            'number': '4',
            'text': 'Comments',
            'isActive': false
          }
        },
        {
          'id': 3,
          'category': 'Rooms',
          'backgroundCard': 'assets/imgs/background/7.jpg',
          'title': 'The Peninsula Manilae',
          'like': {
            'icon': 'thumbs-up',
            'text': 'Like',
            'number': '4',
            'isActive': true
          },
          'comment': {
            'icon': 'chatbubbles',
            'number': '4',
            'text': 'Comments',
            'isActive': false
          }
        }
      ]
    }
  }

  //* Data Set for page 10
  getDataForLayout10 = (): any => {
    return {
      'toolbarTitle': 'FadeIn Right',
      'items': [
        {
          'id': 1,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/20.jpg',
          'title': '45 Park Lane',
          'subtitle': '2 beds',
          'price': '$ 20 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/23.jpg',
          'title': 'Encore Macau',
          'subtitle': '3 beds',
          'price': '$ 700 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/21.jpg',
          'title': 'Bulgari Hotel London',
          'subtitle': '2 beds',
          'price': '$ 300 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/22.jpg',
          'title': 'Belmond El Encanto',
          'subtitle': '1 beds',
          'price': '$ 500 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'avatarTitle': 'Jason Graham',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/24.jpg',
          'title': 'The Alpina Gstaad',
          'subtitle': '3 beds',
          'price': '$ 400 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    }
  }


  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('animation/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
